import { useEffect, useState } from "react";
import { Socket } from "socket.io-client";
import io from "socket.io-client";
import { DefaultEventsMap } from "@socket.io/component-emitter";
import Header from "../components/Header";
import MessageBox from "../components/MessageBox";
import InputBox from "../components/InputBox";
import Popup from "../components/Popup";
import styles from "./css/Chatting.module.css";
import { ChatDto, UserInfo } from "../interfaces/chat.interface";

interface ChattingProps {
  setPage: React.Dispatch<React.SetStateAction<number>>;
  loginId: number;
  selectedCharacter: UserInfo;
  setSelectedCharacter: React.Dispatch<React.SetStateAction<UserInfo>>;
}

export default function Chatting({
  setPage,
  loginId,
  selectedCharacter,
  setSelectedCharacter,
}: ChattingProps) {
  const [socket, setSocket] = useState<Socket<
    DefaultEventsMap,
    DefaultEventsMap
  > | null>(null);
  const [messages, setMessages] = useState<ChatDto[]>([]);
  const [users, setUsers] = useState<UserInfo[]>([]);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const newSocket = io("https://ssammutalk.mukho.r-e.kr", {
      transports: ["websocket"],
    });
    setSocket(newSocket);

    // 사용자 정보 전송
    newSocket.emit("users", {
      userId: selectedCharacter["userId"],
      nickname: selectedCharacter["nickname"],
      characterImageUrl: selectedCharacter["characterImageUrl"],
    });

    // 메시지 수신
    newSocket.on("chat", (message: ChatDto) => {
      setMessages((prev) => [...prev, message]);
    });

    // 사용자 목록 수신
    newSocket.on("users", (userList: UserInfo[]) => {
      setUsers(userList);
    });

    return () => {
      if (newSocket) {
        newSocket.emit("out"); // 서버에 연결 해제 이벤트 전송
        newSocket.disconnect();
      }
    };
  }, [selectedCharacter]);

  const handleBackClick = () => {
    if (socket) {
      socket.emit("out"); // 서버에 연결 해제 이벤트 전송
      socket.disconnect();
      setSocket(null);
    }
    setSelectedCharacter({
      ...selectedCharacter,
      nickname: "",
      characterImageUrl: "",
    });
    setPage(1);
  };

  const handleSendMessage = (message: string) => {
    if (socket) {
      const chatData: ChatDto = {
        userId: selectedCharacter["userId"],
        nickname: selectedCharacter["nickname"],
        message,
        characterImageUrl: selectedCharacter["characterImageUrl"],
        timestamp: new Date().toISOString(),
      };
      socket.emit("chat", chatData);
    }
  };

  return (
    <div className={styles.container}>
      <Header
        type="chat"
        onBackClick={handleBackClick}
        userCount={users.length}
        onUserCountClick={() => setShowPopup(true)}
      />
      <div className={styles.content}>
        <MessageBox messages={messages} loginId={loginId} />
      </div>
      <InputBox onSendMessage={handleSendMessage} />
      {showPopup && <Popup users={users} onClose={() => setShowPopup(false)} />}
    </div>
  );
}
